<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')" :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                                <div class="baiseback" style="min-height: 100vh">
                                    <ForumLeft></ForumLeft>
                                </div>
                            </div>
                            <!-- <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div> -->
                        </div>
                    </div>
                    <div :class="(webW?'col-sm-7':'col-sm-12')">
                         <div v-if="!webW">
                                <div class="baiseback" v-if="hasTypeInfo && typeId>0">
                                    <div class="center">
                                        <!-- <img :src="typeInfo.icon" class="typeicon">
                                            <div class="h10"></div>
                                            <p><b>{{typeInfo.name}}</b></p>
                                            <p class=" typedesc margintop20"><span>简介：</span><span class="typezt">  {{typeInfo.tdesc==''?'暂无':typeInfo.tdesc}}</span>
                                            </p> -->
                                        <!-- <td class="leftmargin">  
                                                    <p ><b>{{typeInfo.name}}</b></p>
                                                     <p class=" typedesc margintop20"><span >简介：</span><span class="typezt">  {{typeInfo.tdesc==''?'暂无':typeInfo.tdesc}}</span>
                                                    </p>                          
                                                </td> -->
                                    </div>
                                    <div class="flex1">
                                        <!-- <div>
                                            <p><b><img :src="typeInfo.icon" class="typeiconForCir"></b></p>
                                        </div> -->
                                        <div>
                                            <p><b>{{typeInfo.name}}</b></p>
                                            <p class="typedesc"><span>简介：</span><span class="typezt">  {{typeInfo.tdesc==''?'暂无':typeInfo.tdesc}}</span>
                                            </p>
                                        </div>
                                        <!-- <td><p class="h10"><b>{{typeInfo.name}}</b></p></td> -->
                                    </div>
                                    <div class="button-container">
                                        <el-button v-waves class="button-container" style=" width: 250px;" type="primary" :size="webW?'small':'mini'" icon="el-icon-plus" position: relative @click="handleAdd">
                                            发帖
                                        </el-button>
                                    </div>
                                    <div class="baiseback" id="forumMain">
                                        <el-tabs v-model="activeName" :stretch="true" @tab-click="tabClick">
                                            <el-tab-pane label="最新" name="zx"></el-tab-pane>
                                            <el-tab-pane label="收录" name="jh"></el-tab-pane>
                                            <el-tab-pane label="最热" name="zr"></el-tab-pane>
                                        </el-tabs>
                                    </div>
                                    <div class="h40 clear"></div>
                                    <p class=" typedesc" v-if="typeInfo.type=='sub'"><span>群成员：</span><span @click="goTeamer" class="pull-right hander">全部<i
                                                class="el-icon-arrow-right"></i></span></p>
                                    <div class="typetj3" v-if="typeInfo.type=='sub'" :style="'height:'+(40*(parseInt(typeInfo.ptli.length/4+1)))+'px;'">
                                        <div v-if="typeInfo.addType=='1'||(typeInfo.addType=='2'&&IisFqz)">
                                            <div v-for="(t,i) in typeInfo.ptli" class="item" v-if="i<15" :key="i">
                                                <el-tooltip effect="dark" :content="t.uname" placement="top-start">
                                                    <img :src="t.faceimg" @click="goUHome(t.manageUid)" class="hander">
                                                </el-tooltip>
                                            </div>
                                            <div class="item" @click="goaddcy">
                                                <img src="../../../assets/img/addpt.png">
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-for="(t,i) in typeInfo.ptli" class="item" v-if="i<16" :key="i">
                                                <el-tooltip effect="dark" :content="t.uname" placement="top-start">
                                                    <img :src="t.faceimg" @click="goUHome(t.manageUid)" class="hander">
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div :class="(this.TopData.length > 0?'zhidingdiv':'')" v-if="typeId > 0 && this.query.pageNo == 1">
                             <div  v-show="isSticky">
                                     <TopItem></TopItem>
                            </div>
                        </div>
                         
                        <div class="tupianbb" v-if="typeId>0">
                                <img src="../../../assets/img/type_back2.jpg" alt="">
                            </div>
                        <div class="fixedMenuSubUp">



                            <div class="h20" v-if="typeId>0"></div>
                            <!-- <el-switch v-if="webW"
                                       @click="openAutoReflashFunc"
                                       :style="'position: absolute;z-index: 1;right:10px;margin-top:10px;'"
                                       active-text="下拉刷新"
                                       v-model="openAutoReflash"
                                       active-color="#13ce66"
                                       inactive-color="#dddddd">
                            </el-switch> -->
                            <ForumItem @refresh="refreshTopItem"></ForumItem>
                            <div class="baiseback" v-if="tableDataloading">
                                <div class="center">
                                    <img src="../../../assets/img/loading.gif">
                                    <p class="typedesc">数据加载中....</p>
                                </div>
                            </div>
                            <div class="baiseback" style="height: 100vh;" v-if="!tableDataloading&&tableData.length==0">
                                <div class="center">
                                    <img src="../../../assets/img/zwsj.png">
                                    <p class="typedesc">暂无数据</p>
                                </div>
                            </div>
                            <div class="baiseback12px">
                                <div class="center">
                                    <el-pagination 
                                    @current-change="handlePageChange" 
                                    :current-page="query.pageNo" 
                                    :page-size="query.pageSize" 
                                    :pager-count="5"
                                    :hide-on-single-page="true"
                                    layout=" prev, pager, next" 
                                    :total="pageTotal">
                                    </el-pagination>
                                    <!-- <pagination
                                     :total="total"
                                     :page.sync="page.page"
                                     :limit.sync="page.limit"
                                     @pagination="getList()"
                                    /> -->
                                </div>
                                <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>
                            </div>
                            <div class="baiseback">
                                <Footer></Footer>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3" v-if="webW">
                        <div id="JfRightMenuOut">
                            <div :class="(fixedRightmenu?'fixedMenuRT':'')" :style="fixedRightmenu?('width:'+RightMenuWidth+'px'):''" id="JfRightMenu">
                                <div class="baiseback" v-if="hasTypeInfo && typeId>0">
                                    <div class="flex1">
                                        <!-- <div>
                                            <p><b><img :src="typeInfo.icon" class="typeiconForCir"></b></p>
                                        </div> -->
                                        <div>
                                            <p class="center"><b> </b></p>
                                            <p class="center"><b> </b></p>
                                            <p class="center"><b>{{typeInfo.name}}</b></p>
                                            <p class="typedesc"><span>简介：</span><span class="typezt">  {{typeInfo.tdesc==''?'暂无':typeInfo.tdesc}}</span>
                                            </p>
                                        </div>
                                        <!-- <td><p class="h10"><b>{{typeInfo.name}}</b></p></td> -->
                                    </div>
                                    <div class="button-container">
                                        <el-button v-waves class="button-container" style=" width: 80%;" type="primary" :size="webW?'small':'mini'" icon="el-icon-plus" position: relative @click="handleAdd">
                                            发帖
                                        </el-button>
                                    </div>
                                    <div class="baiseback" id="forumMain">
                                        <el-tabs v-model="activeName" :stretch="true" @tab-click="tabClick">
                                            <el-tab-pane label="最新" name="zx"></el-tab-pane>
                                            <el-tab-pane label="收录" name="jh"></el-tab-pane>
                                            <el-tab-pane label="最热" name="zr"></el-tab-pane>
                                        </el-tabs>
                                    </div>
                                    <div class="h40 clear"></div>
                                    <p class=" typedesc" v-if="typeInfo.type=='sub'"><span>群成员：</span><span @click="goTeamer" class="pull-right hander">全部<i
                                                class="el-icon-arrow-right"></i></span></p>
                                    <div class="typetj3" v-if="typeInfo.type=='sub'" :style="'height:'+(40*(parseInt(typeInfo.ptli.length/4+1)))+'px;'">
                                        <div v-if="typeInfo.addType=='1'||(typeInfo.addType=='2'&&IisFqz)">
                                            <div v-for="(t,i) in typeInfo.ptli" class="item" v-if="i<15" :key="i">
                                                <el-tooltip effect="dark" :content="t.uname" placement="top-start">
                                                    <img :src="t.faceimg" @click="goUHome(t.manageUid)" class="hander">
                                                </el-tooltip>
                                            </div>
                                            <div class="item" @click="goaddcy">
                                                <img src="../../../assets/img/addpt.png">
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-for="(t,i) in typeInfo.ptli" class="item" v-if="i<16" :key="i">
                                                <el-tooltip effect="dark" :content="t.uname" placement="top-start">
                                                    <img :src="t.faceimg" @click="goUHome(t.manageUid)" class="hander">
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="clear h20  " v-if="hasTypeInfo && typeId>0"></div>
                            </div>
                            <!-- <div v-if="fixedRightmenu" :style="'width:'+RightMenuWidth+'px'"><br></div> -->
                        </div>
                    </div>
                </div>
                <div class="h100"></div>
                <img src="../../../assets/img/cygl.png" @click="goaddcy" v-if="!webW &&( typeInfo.addType=='1'||(typeInfo.addType=='2'&&IisFqz) )" class="gotop hander" style="bottom: 130px;">
                <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">
            </div>
            <el-dialog title="预览视频" :visible.sync="videoVisible" :append-to-body="true" @close="closeYlVideodialog" :fullscreen="webW?false:true" :class="webW?'':'heiseplayertck'">
                <video :src="playVideo" id="ylvideo" controls style="width: 100%;"></video>
            </el-dialog>
            <el-dialog title="新增帖子" :visible.sync="dialogFormVisible" center :modal="false" @close="closeDialog" :fullscreen="webW?false:true" :class="webW?'':'heiseplayertck1'">
                <div class="baiseback" v-if="typeId>0">
                    <el-form label-width="0" :model="dataForm" :rules="dataFormRule" ref="dataForm">
                        <el-form-item prop="ftitle">
                            <el-input v-model="dataForm.ftitle" placeholder="请输入标题" :disabled="nouse || !ihasRelease"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <quill-editor ref="myQuillEditor" v-model="dataForm.fcontext" :options="editorOption" :disabled="nouse|| !ihasRelease" />
                            <img @click="uploadImgsHandleShow" src="../../../assets/img/upimg.png" class="editor_upimg">
                            <img @click="uploadVideosHandleShow" src="../../../assets/img/upvideo.png" class="editor_upvideo">
                        </el-form-item>
                        <div v-show="showUploadType==1">
                            <el-upload ref="uploadImgs" :auto-upload="true" accept="image/*" :limit="maximgnum" multiple :action=FILE_ACTION :list-type="webW?'picture-card':'picture'" :on-exceed="handleExceed" :on-success="handleFileSuccess" :before-upload="beforeUpload" :on-change="handleChangeUpload"
                                :on-remove="handleRemoveUpload" :on-error="handleErrorUpload">
                                <i v-if="webW" class="el-icon-plus"></i>
                                <div v-else class="videoupcls"><i class="el-icon-plus icon"></i></div>
                            </el-upload>
                            <p v-if="update_imgs_numobj.all>0" style="margin-top: 20px;">
                                <el-alert v-if="update_imgs_numobj.ing==0" :title="'已成功上传'+update_imgs_numobj.succ+'个图片'" type="success" show-icon>
                                </el-alert>
                                <el-alert v-if="update_imgs_numobj.ing>0" :title="'正在上传'+update_imgs_numobj.ing+'个图片，已成功上传'+update_imgs_numobj.succ+'个图片 '" type="warning" effect="dark" description="图片上传中请勿离开该页面..." show-icon>
                                </el-alert>
                                <el-alert v-if="update_imgs_numobj.error>0" :title="'上传失败'+update_imgs_numobj.error+'个图片 '" type="error" show-icon>
                                </el-alert>
                            </p>
                            <p class="tipc">提示：最多上传{{maximgnum}}张图片</p>
                        </div>
                        <div v-show="showUploadType==2">
                            <el-upload ref="uploadVideos" :auto-upload="true" accept="video/*" :limit="maxvideonum" multiple :action=FILE_ACTION2 list-type="fileList" :on-exceed="handleExceed2" :on-success="handleFileSuccess2" :before-upload="beforeUpload2" :on-change="handleChangeUpload2"
                                :on-remove="handleRemoveUpload2" :on-error="handleErrorUpload2" :on-preview="handlePreviewUpload2">
                                <div class="videoupcls"><i class="el-icon-video-camera icon"></i></div>
                            </el-upload>
                            <p v-if="update_videos_numobj.all>0" style="margin-top: 20px;">
                                <el-alert v-if="update_videos_numobj.ing==0" :title="'已成功上传'+update_videos_numobj.succ+'个视频'" type="success" show-icon>
                                </el-alert>
                                <el-alert v-if="update_videos_numobj.ing>0" :title="'正在上传'+update_videos_numobj.ing+'个视频，已成功上传'+update_videos_numobj.succ+'个视频 '" type="warning" effect="dark" description="视频上传中请勿离开该页面..." show-icon>
                                </el-alert>
                                <el-alert v-if="update_videos_numobj.error>0" :title="'上传失败'+update_videos_numobj.error+'个图片 '" type="error" show-icon>
                                </el-alert>
                            </p>
                            <p class="tipc">提示：最多上传{{maxvideonum}}个视频，最大{{maxvideoarea}}M</p>
                        </div>
                        <div v-if="openVote">
                            <el-form-item v-for="(t,i) in voteItemli" :key="i">
                                <el-row>
                                    <el-col :span="webW?19:18">
                                        <el-input v-model="t.vitem" placeholder="请输入选项"></el-input>
                                    </el-col>
                                    <el-col :span="webW?5:6">
                                        <el-button @click="delItem(t,i)" type="danger" icon="el-icon-delete">
                                            {{webW?'删除选项':''}}
                                        </el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="addItem" size="mini" type="primary" icon="el-icon-plus">
                                    添加选项
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                选项类型：
                                <el-radio v-model="dataForm.vtype" label="dx">单选</el-radio>
                                <el-radio v-model="dataForm.vtype" label="mx">多选</el-radio>
                            </el-form-item>
                            <el-form-item>
                                投票日期：
                                <el-date-picker :class="webW?'':'riqixzq'" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="dataForm.voteDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :disabled="nouse || !ihasRelease">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox v-model="dataForm.vshowNumBoo" :disabled="nouse || !ihasRelease">
                                    显示已投票数
                                </el-checkbox>
                                <el-checkbox v-model="dataForm.vshowPeopleBoo" :disabled="nouse || !ihasRelease">显示已投票用户
                                </el-checkbox>
                            </el-form-item>
                        </div>
                        <div style="height: 30px;" v-if="!webW"></div>
                        <div class="Tool_check">
                            <el-checkbox @change="openVoteHandle" v-model="openVote" :disabled="nouse || !ihasRelease">投票
                            </el-checkbox>
                            <el-button round size="mini" style="margin-left: 10px;" type="warning" :disabled="nouse || !ihasRelease || (update_imgs_numobj.ing!=undefined&&update_imgs_numobj.ing>0) || (update_videos_numobj.ing!=undefined&&update_videos_numobj.ing>0) " @click="saveEdit">
                                发表
                            </el-button>
                            <el-button round size="mini" style="margin-left: 10px;" type="info" @click="closeDialog">取消</el-button>
                        </div>
                    </el-form>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import {
        quillEditor,
        Quill
    } from 'vue-quill-editor'
    import {
        container,
        ImageExtend,
        QuillWatch
    } from 'quill-image-extend-module'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import quillEmoji from 'quill-emoji'
    import 'quill-emoji/dist/quill-emoji.css'
    Quill.register('modules/ImageExtend', ImageExtend)
    Quill.register('modules/quillEmoji', quillEmoji)
    import '../../../api/image-paste.min.js';
    let CON_ACTION = process.env.VUE_APP_API_ROOT + '/common/upimg?type=forum_detail';
    let vm = null;
    import {
        dealResult,
        getWindowWidth,
        lianjie,
        messageSocketUrl,
        maxvideoarea,
        maxvideonum,
        maximgnum
    } from '../../../api/common'
    import {
        getTypeForumInfo,
        forumpage,
        forumtop,
        saveVoteItem,
        releaseForum
    } from '../../../api';
    import PubSub from 'pubsub-js';
    import Footer from "../Footer";
    import ForumItem from "./ForumItem";
    import TopItem from "./TopItem";
    import ForumLeft from "./ForumLeft";
    import Pagination from '@/components/Pagination'
    export default {
        name: 'Forum',
        components: {
            ForumLeft,
            quillEditor,
            Footer,
            ForumItem,
            TopItem,
            Pagination
        },
        data() {
            return {
                showUploadType: 0,
                FILE_ACTION: '',
                maximgnum: 0,
                file_list_choose: [],
                update_imgs_numobj: {
                    all: 0
                },
                FILE_ACTION2: '',
                maxvideonum: 0,
                maxvideoarea: 0,
                file_list_choose_video: [],
                update_videos_numobj: {
                    all: 0
                },
                isSticky: true,
                videoVisible: false,
                dialogFormVisible: false,
                playVideo: '',
                openVote: false,
                voteItemli: [],
                webW: true,
                activeName: 'zx',
                IisFqz: false, //是否是副群主，群主
                openAutoReflash: false,
                scrolltop: false,
                nouse: false, //禁用
                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,
                fixedRightmenu: false,
                RightMenuWidth: 0,
                lander: {},
                //发帖
                dataForm: {
                    id: '',
                    ftitle: '',
                    fcontext: '',
                    vtype: 'dx',
                    voteDate: '',
                    vshowNumBoo: false,
                    vshowPeopleBoo: false,
                },
                dataFormRule: {
                    ftitle: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur',
                        min: 1,
                        max: 100
                    }],
                },
                typeId: 0,
                typeInfo: {},
                hasTypeInfo: false,
                ihasReplay: true,
                ihasRelease: true,
                //帖子信息
                tableData: [],
                //置顶信息
                TopData: [],
                tableDataloading: true,
                tableDataFinish: false, //避免滚动条在最后一直请求
                query: {
                    pageNo: 1,
                    pageSize: 20,
                },
                pageTotal: 0,
                //最新评论
                commentli: [],
                commentliLoading: true,
                //最热帖子
                hotForumLi: [],
                hotForumLiLoading: true,
                editorOption: {
                    modules: {
                        'emoji-toolbar': true,
                        'emoji-shortname': true,
                        /* 还有一些其他的模块*/
                        imagePaste: {
                            addImageBlob: function(blob, callback) {
                                var formData = new FormData()
                                formData.append('file', blob);
                                // your upload function, get the uploaded image url, add then
                                let config = {
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                        "Accept": "*/*",
                                        "uidh": JSON.parse(vm.$store.state.logininfo).uid,
                                        "tokenh": JSON.parse(vm.$store.state.logininfo).token
                                    }
                                }
                                // 上传接口
                                axios.post(CON_ACTION, formData, config).then(res => {
                                    let imgUrl = res.data.obj // 服务器返回的图片url
                                    callback(imgUrl)
                                })
                            }
                        },
                        ImageExtend: { // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
                            loading: true, //可选参数 是否显示上传进度和提示语
                            name: 'file', // 图片参数名
                            size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
                            action: CON_ACTION, // 服务器地址, 如果action为空，则采用base64插入图片
                            // response 为一个函数用来获取服务器返回的具体图片地址
                            // 例如服务器返回{code: 200; data:{ url: 'baidu.com'}}
                            // 则 return res.data.url
                            response: res => {
                                return res.obj;
                            },
                            headers: xhr => {
                                //上传图片请求需要携带token的 在xhr.setRequestHeader中设置
                                xhr.setRequestHeader(
                                    "uidh",
                                    JSON.parse(vm.$store.state.logininfo).uid
                                );
                                xhr.setRequestHeader(
                                    "tokenh",
                                    JSON.parse(vm.$store.state.logininfo).token
                                );
                            }, // 可选参数 设置请求头部
                            sizeError: () => {}, // 图片超过大小的回调
                            start: () => {}, // 可选参数 自定义开始上传触发事件
                            end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
                            error: () => {}, // 可选参数 上传失败触发的事件
                            success: () => {}, // 可选参数  上传成功触发的事件
                            // change: (xhr, formData) => {
                            // xhr.setRequestHeader('myHeader','myValue')
                            // formData.append('token', 'myToken')
                            // } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
                        },
                        toolbar: {
                            container: ['emoji'], //container,
                            handlers: {
                                'image': function() {
                                    QuillWatch.emit(this.quill.id)
                                }
                            }
                        }
                    },
                    //主题
                    theme: "snow",
                    placeholder: "请输入正文"
                },
            };
        },
        methods: {
            uploadImgsHandleShow() {
                if (this.nouse) this.$message.info('你已被禁言');
                else if (!this.ihasRelease) this.$message.info('你没有发帖权限');
                else {
                    if (this.showUploadType != 1) this.showUploadType = 1;
                    else this.showUploadType = 0;
                }
            },
            uploadVideosHandleShow() {
                if (this.nouse) this.$message.info('你已被禁言');
                else if (!this.ihasRelease) this.$message.info('你没有发帖权限');
                else {
                    if (this.showUploadType != 2) this.showUploadType = 2;
                    else this.showUploadType = 0;
                }
            },
            handleExceed() {
                if (this.file_list_choose.length < this.maximgnum) {
                    this.$message.error('最多上传' + this.maximgnum + "张图片");
                    return false;
                }
            },
            handleErrorUpload(err, file, fileList) {
                console.log(err);
                this.getUploadImgNum();
                if (this.update_imgs_numobj.error == undefined) this.update_imgs_numobj.error = 1;
                else this.update_imgs_numobj.error++;
            },
            handleFileSuccess(res, file) {
                dealResult(res);
                if (res.status == 1) {
                    for (let i = 0; i < this.file_list_choose.length; i++) {
                        if (file.url == this.file_list_choose[i].url) {
                            this.file_list_choose[i].url = res.obj;
                        }
                    }
                } else {
                    this.$message.error('上传失败');
                }
                this.getUploadImgNum();
            },
            beforeUpload() {
            },
            handleChangeUpload(file, fileList) {
                this.file_list_choose = fileList;
                this.getUploadImgNum();
            },
            handleAdd() {
                this.dialogFormVisible = true
            },
            closeDialog() {
                this.dialogFormVisible = false
            },
            handleRemoveUpload(file, fileList) {
                this.file_list_choose = fileList;
                this.getUploadImgNum();
            },
            getUploadImgNum() {
                let all = this.file_list_choose.length;
                let succ = 0;
                let ing = 0;
                for (let i = 0; i < this.file_list_choose.length; i++) {
                    if (this.file_list_choose[i].url != undefined && this.file_list_choose[i].url.indexOf('upimg') > -1) {
                        succ++;
                    } else {
                        ing++;
                    }
                }
                this.update_imgs_numobj = {
                    succ: succ,
                    ing: ing,
                    all: all
                }
            },
            handleExceed2() {
                if (this.file_list_choose_video.length < this.maxvideonum) {
                    this.$message.error('最多上传' + this.maxvideonum + "个视频");
                    return false;
                }
            },
            handleErrorUpload2(err, file, fileList) {
                console.log(err);
                this.getUploadVideoNum();
                if (this.update_videos_numobj.error == undefined) this.update_videos_numobj.error = 1;
                else this.update_videos_numobj.error++;
            },
            handleFileSuccess2(res, file) {
                dealResult(res);
                if (res.status == 1) {
                    for (let i = 0; i < this.file_list_choose_video.length; i++) {
                        if (file.url == this.file_list_choose_video[i].url) {
                            this.file_list_choose_video[i].url = res.obj;
                        }
                    }
                } else {
                    this.$message.error('上传失败');
                }
                this.getUploadVideoNum();
            },
            beforeUpload2(file) {
                const isLt2M = file.size / 1024 / 1024 <= this.maxvideoarea;
                if (!isLt2M) {
                    this.$message.error('视频大小不能超过 ' + this.maxvideoarea + 'MB!');
                }
                return isLt2M;
            },
            handleChangeUpload2(file, fileList) {
                this.file_list_choose_video = fileList;
                this.getUploadVideoNum();
            },
            handleRemoveUpload2(file, fileList) {
                this.file_list_choose_video = fileList;
                this.getUploadVideoNum();
            },
            handlePreviewUpload2(file) {
                this.playVideo = file.url;
                setTimeout(() => {
                    let ylvideo = document.getElementById('ylvideo');
                    ylvideo.play();
                }, 2000);
                this.videoVisible = true;
            },
            closeYlVideodialog() {
                let ylvideo = document.getElementById('ylvideo');
                setTimeout(() => {
                    ylvideo.pause();
                }, 200)
            },
            getUploadVideoNum() {
                let all = this.file_list_choose_video.length;
                let succ = 0;
                let ing = 0;
                for (let i = 0; i < this.file_list_choose_video.length; i++) {
                    if (this.file_list_choose_video[i].url != undefined && this.file_list_choose_video[i].url.indexOf('upimg') > -1) {
                        succ++;
                    } else {
                        ing++;
                    }
                }
                this.update_videos_numobj = {
                    succ: succ,
                    ing: ing,
                    all: all
                }
            },
            gotoA(a) {
                window.open(lianjie[a], '_blank')
            },
            goUHome(uid) {
                this.$router.push('Home?type=myforum&authorId=' + uid);
            },
            openVoteHandle() {
                if (this.openVote) {
                    this.voteItemli = [];
                    this.voteItemli.push({
                        vitem: ''
                    });
                    this.voteItemli.push({
                        vitem: ''
                    });
                    this.dataForm.voteDate = '';
                    this.dataForm.vshowNumBoo = false;
                    this.dataForm.vshowPeopleBoo = false;
                    this.dataForm.vtype = "dx";
                }
            },
            delItem(t, index) {
                this.voteItemli.splice(index, 1);
            },
            addItem() {
                this.voteItemli.push({
                    vitem: ''
                });
            },
            goaddcy() {
                this.$router.push('TeamerAdd?TeamType=addcy&Team_typeId=' + this.typeId);
            },
            goTeamer() {
                this.$router.push('Teamer?TeamType=cy&Team_typeId=' + this.typeId);
            },
            goforumDetail(t, index) {
                this.$router.push('ForumDetail?id=' + t.id + "&goPosition=top");
            },
            tabClick(tab, event) {
                this.query.orderby = this.activeName;
                this.query.pageNo = 1;
                this.tableData = [];
                this.tableDataFinish = false;
                PubSub.publish('forumDataListForItem', null);
                this.getForumPage();
            },
            openAutoReflashFunc() {
                if (this.openAutoReflash) this.tableDataFinish = false;
            },
            gotopFunc() {
                if (document.documentElement != undefined) document.documentElement.scrollTop = 0;
                if (document.body != undefined) document.body.scrollTop = 0;
            },
            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData = [];
                PubSub.publish('forumDataListForItem', null);
                this.getForumPage();
                if(val == 1){
                    PubSub.publish('forumDataListForTop', null);
                    this.getForumTop();
                }
                this.tableDataFinish = false;
                let forumMain = document.getElementById('forumMain');
                let top = forumMain.offsetTop;
                document.documentElement.scrollTop = top;
                document.body.scrollTop = top;
            },
            getToday() {
                let myDate = new Date();
                let y = myDate.getFullYear();
                let m = myDate.getMonth() + 1;
                let d = myDate.getDate();
                if (parseInt(m) < 10) m = "0" + m;
                if (parseInt(d) < 10) d = "0" + d;
                return y + "-" + m + "-" + d;
            },
            saveVoteItem(o) {
                o.uid = this.lander.uid;
                o.token = this.lander.token;
                saveVoteItem(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //保存操作
            saveEdit() {
                //去除<p>标签
                this.dataForm.fcontext = this.dataForm.fcontext.replace(/<p><br><\/p>/g, '<br />').replace(/<p>([^<]*?)<\/p>/gi, '$1<br/>').replace(/<br>$/, "");
                //
                this.$refs.dataForm.validate(valid => {
                    if (this.$refs.myQuillEditor.value == '' || this.dataForm.fcontext.trim().length == 0) {
                        this.$message.error('请输入正文');
                        return;
                    }
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {
                        this.dataForm.isVote = '0';
                        if (this.openVote) {
                            this.dataForm.isVote = '1';
                            if (this.voteItemli.length < 2) {
                                this.$message.info("至少2个选项");
                                return;
                            }
                            for (let i = 0; i < this.voteItemli.length; i++) {
                                if (this.voteItemli[i].vitem == '') {
                                    this.$message.info("选项不可为空");
                                    return;
                                }
                                if (this.voteItemli[i].vitem.length > 250) {
                                    this.$message.info("选项字数不可超过250");
                                    return;
                                }
                            }
                            if (this.dataForm.voteDate.length < 2) {
                                this.$message.info("请选择投票日期");
                                return;
                            }
                            this.dataForm.vstartTs = this.dataForm.voteDate[0];
                            this.dataForm.vendTs = this.dataForm.voteDate[1];
                            if (this.dataForm.vstartTs < this.getToday()) {
                                this.$message.info("开始日期不可以是过去时间");
                                return;
                            }
                            this.dataForm.vshowNum = '0';
                            if (this.dataForm.vshowNumBoo) this.dataForm.vshowNum = '1';
                            this.dataForm.vshowPeople = '0';
                            if (this.dataForm.vshowPeopleBoo) this.dataForm.vshowPeople = '1';
                        }
                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;
                        this.dataForm.typeId = this.typeId;
                        this.dataForm.ftype = this.typeInfo.type;
                        if (this.file_list_choose.length > 0) {
                            let imgs = "";
                            for (let i = 0; i < this.file_list_choose.length; i++) {
                                imgs += this.file_list_choose[i].url + ","
                            }
                            this.dataForm.imgs = imgs;
                        }
                        if (this.file_list_choose_video.length > 0) {
                            let videos = "";
                            for (let i = 0; i < this.file_list_choose_video.length; i++) {
                                videos += this.file_list_choose_video[i].url + ","
                            }
                            this.dataForm.videos = videos;
                        }
                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        releaseForum(this.dataForm).then((res) => {
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.dataForm.ftitle = '';
                                this.dataForm.fcontext = '';
                                this.openVote = false;
                                this.$refs.uploadImgs.clearFiles();
                                this.file_list_choose = [];
                                this.update_imgs_numobj = {
                                    all: 0
                                };
                                this.dataForm.imgs = undefined;
                                this.$refs.uploadVideos.clearFiles();
                                this.file_list_choose_video = [];
                                this.update_videos_numobj = {
                                    all: 0
                                };
                                this.dataForm.videos = undefined;
                                let forumObj = res.data.obj.forumObj;
                                if (this.dataForm.isVote == '1') {
                                    for (let i = 0; i < this.voteItemli.length; i++) {
                                        this.saveVoteItem({
                                            vitem: this.voteItemli[i].vitem,
                                            forumId: forumObj.id
                                        });
                                    }
                                }
                                this.query.pageNo = 1;
                                this.tableData = [];
                                // setTimeout(() => {
                                //     PubSub.publish('forumDataListForItem', null);
                                //     this.getForumPage();
                                // }, 2000)
                                // setTimeout(() => {
                                //     this.getTypeForumInfoFunc();
                                // }, 100 )
                                //右边小红点添加帖子提醒
                                setTimeout(() => {
                                    let atli = res.data.obj.atli;
                                    if (atli != null && atli.length > 0) {
                                        for (let i = 0; i < atli.length; i++) {
                                            let mess2 = {
                                                name: this.lander.uid + "",
                                                receiver: atli[i] + "",
                                                msg: this.lander.uname + "  在帖子里 @ 了你"
                                            }
                                            this.sendMessage(JSON.stringify(mess2))
                                        }
                                    }
                                    let fobj = {
                                        typeId: forumObj.typeId,
                                        ftype: forumObj.ftype
                                    };
                                    let mess2 = {
                                        name: this.lander.uid + "",
                                        type: "addForumTip",
                                        forumObj: fobj
                                    };
                                    this.sendMessage(JSON.stringify(mess2));
                                }, 200)
                                //跳转页面提醒
                                setTimeout(() => {
                                    this.loading.close();
                                    this.$router.push("/ReleaseForumSucc?forumId=" + forumObj.id + "&typeId=" + this.typeId);
                                }, 300);
                                //弹窗提醒+自动涮新数据
                                // this.$alert('发布成功', '提示', {
                                //     confirmButtonText: '确定',
                                //     type:'success',
                                //     customClass: 'msgboxgf',
                                //     callback: action => {
                                //             this.loading.close();
                                //         this.$message.info(" 数据刷新中....");
                                //     }
                                // });
                            } else {
                                this.loading.close();
                                this.$message.error(res.data.msg)
                            }
                        }).catch((err) => {
                            this.loading.close();
                            console.log(err)
                            this.$alert('发布失败', '提示', {
                                confirmButtonText: '确定',
                                type: 'error',
                                customClass: 'msgboxgf',
                                callback: action => {
                                }
                            });
                        });
                        this.closeDialog()
                    }
                })
            },
            sendMessage(msg) {
                let that = this;
                console.log(that.$messageSocket.ws);
                if (that.$messageSocket.ws && that.$messageSocket.ws.readyState == 1) {
                    console.log("发送信息", msg);
                    that.$messageSocket.ws.send(msg);
                } else {
                    that.ws = new WebSocket(messageSocketUrl + this.lander.uid);
                    that.$messageSocket.setWs(that.ws);
                    setTimeout(() => {
                        console.log("setTimeout发送信息", msg);
                        that.$messageSocket.ws.send(msg);
                    }, 2000)
                }
            },
            getTypeForumInfoFunc() {
                this.hotForumLiLoading = true;
                this.commentliLoading = true;
                this.hotForumLi = [];
                this.commentli = [];
                getTypeForumInfo({
                    uid: this.lander.uid,
                    token: this.lander.token,
                    typeId: this.typeId
                }).then((res) => {
                    dealResult(res.data);
                    this.hotForumLiLoading = false;
                    this.commentliLoading = false;
                    if (res.data.status == 1) {
                        this.typeInfo = res.data.obj;
                        this.hasTypeInfo = true;
                        if (this.typeInfo.type == "forum") {
                            if (this.typeInfo.ihasSee != '1') {
                                sessionStorage.systip = "你没有权限浏览【" + this.typeInfo.name + "】";
                                this.$router.replace("/Tip");
                                return;
                            }
                            if (this.typeInfo.ihasReplay != '1') {
                                this.ihasReplay = false;
                                setTimeout(() => {
                                    this.$message.error("你没有评论权限")
                                }, 2000)
                            } else this.ihasReplay = true;
                            if (this.typeInfo.ihasRelease != '1') {
                                this.ihasRelease = false;
                                setTimeout(() => {
                                    this.$message.error("你没有发帖权限")
                                }, 4000)
                            } else this.ihasRelease = true;
                            res.data.obj.ihasReplay = this.ihasReplay;
                            res.data.obj.ihasRelease = this.ihasRelease;
                        }
                        PubSub.publish('IisFqzFromIndex', false);
                        if (this.typeInfo.type == "sub" && this.typeInfo.utli != null) {
                            for (let i = 0; i < this.typeInfo.utli.length; i++) {
                                if (this.lander.uid == this.typeInfo.utli[i].manageUid) {
                                    this.IisFqz = true;
                                    PubSub.publish('IisFqzFromIndex', true);
                                    console.log("------i is fqz---------")
                                    break;
                                }
                            }
                        }
                        PubSub.publish('IisBanzhuFromIndex', false);
                        if (this.typeInfo.type == "forum" && this.typeInfo.utli != null) {
                            for (let i = 0; i < this.typeInfo.utli.length; i++) {
                                if (this.lander.uid == this.typeInfo.utli[i].manageUid) {
                                    PubSub.publish('IisBanzhuFromIndex', true);
                                    console.log("------i is banzhu---------")
                                    break;
                                }
                            }
                        }
                        PubSub.publish('typeAndQx', res.data.obj);
                        this.hotForumLi = res.data.obj.hotForumli;
                        this.commentli = res.data.obj.lastCommentli;
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //获取帖子分页
            getForumPage() {
                this.tableDataloading = true;
                this.tableDataFinish = false;
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.typeId = this.typeId;
                forumpage(this.query).then((res) => {
                    this.tableDataloading = false;
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li = res.data.obj.list;
                        if (li.length == 0) {
                            this.tableDataFinish = true;
                            return;
                        }
                        for (let i = 0; i < li.length; i++) {
                            li[i].hidden = true;
                            li[i].showComments = false;
                            li[i].commentli = [];
                            li[i].commentliLoading = false;
                            li[i].iscollect = "0";
                            li[i].ishit = "0";
                            li[i].voteItemli = [];
                            li[i].ivote = '0';
                            li[i].myvoteDx = '';
                            li[i].myvoteMx = [];
                            li[i].nowvideo = {
                                vindex: 0,
                                isshow: '0'
                            };
                        }
                        this.tableData = this.tableData.concat(li);
                        PubSub.publish('forumDataListForItem', li);
                        this.pageTotal = res.data.obj.total //该页总共多少条记录
                        if (this.openAutoReflash) {
                            if (res.data.obj.hasNextPage) this.query.pageNo = res.data.obj.nextPage;
                            else this.query.pageNo = this.query.pageNo + 1;
                        }
                        this.fixedmenu();
                    } else {
                        this.tableDataFinish = true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //获取置顶的帖子
            getForumTop() {
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.typeId = this.typeId;
                forumtop(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li = res.data.obj.list;
                        if (li.length == 0) {
                            this.tableDataFinish = true;
                            return;
                        }
                        for (let i = 0; i < li.length; i++) {
                            li[i].hidden = true;
                            li[i].showComments = false;
                            li[i].commentli = [];
                            li[i].commentliLoading = false;
                            li[i].iscollect = "0";
                            li[i].ishit = "0";
                            li[i].voteItemli = [];
                            li[i].ivote = '0';
                            li[i].myvoteDx = '';
                            li[i].myvoteMx = [];
                            li[i].nowvideo = {
                                vindex: 0,
                                isshow: '0'
                            };
                        }
                        this.TopData = this.TopData.concat(li);
                        PubSub.publish('forumDataListForTop', li);
                    } else {
    
                        this.$message.error(res.data.msg)
                    }
                })
            },
            fixedmenu() {
                let that = this;
                let JfLeftMenu = document.getElementById('JfLeftMenu');
                let JfRightMenu = document.getElementById('JfRightMenu');
                window.onscroll = function() {
                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight;
                    let wh = document.documentElement.clientHeight;
                    if (that.webW) {
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;
                        that.RightMenuWidth = JfRightMenu.offsetWidth;
                        //t+wh=h
                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = true;
                        }
                        let rightHeight = JfRightMenu.offsetHeight;
                        let rightTop = JfRightMenu.offsetTop;
                        if (t > rightTop + rightHeight + 50) {
                            that.fixedRightmenu = true;
                        } else {
                            that.fixedRightmenu = true;
                        }
                    }
                    //滚动条到底部加载数据
                    if (t + wh >= h - 100 && that.openAutoReflash && !that.tableDataFinish) {
                        if (!that.tableDataloading) that.getForumPage();
                    }
                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;
                }
            },
             refreshTopItem() {
                           // 这里实现父组件的刷新逻辑
                         console.log('父组件被刷新');
                  }
        },
        mounted() {
            vm = this;
            this.maxvideoarea = maxvideoarea;
            this.maxvideonum = maxvideonum;
            this.maximgnum = maximgnum;
            this.webW = getWindowWidth() >= 1000 ? true : false;
            this.lander = JSON.parse(this.$store.state.logininfo);
            if (this.lander.state != '1') {
                this.nouse = true;
                this.$message.error("你已被禁言")
            }
            this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/common/upimg?type=forum_detail&uid=' + this.lander.uid + "&token=" + this.lander.token;
            this.FILE_ACTION2 = process.env.VUE_APP_API_ROOT + '/common/upimg?type=forum_video&uid=' + this.lander.uid + "&token=" + this.lander.token;
            if (this.$route.query.typeId == undefined) this.typeId = 0;
            else this.typeId = this.$route.query.typeId;
            this.query.pageNo = 1;
            this.tableData = [];
            this.tableDataFinish = false;
            PubSub.publish('forumDataListForItem', null);
            this.getForumPage();
            PubSub.publish('forumDataListForTop', null);
            this.getForumTop();
            this.getTypeForumInfoFunc();
            //固定左右菜单
            this.fixedmenu();
        },
        watch: {
            $route: function(value) {
                if ((value.query.typeId != undefined && value.query.typeId != this.typeId) || value.query.releaseSuccReturnflush == 'need') {
                    this.typeId = value.query.typeId
                    this.query.pageNo = 1;
                    this.tableData = [];
                    this.tableDataFinish = false;
                    PubSub.publish('forumDataListForItem', null);
                    this.getForumPage();
                    PubSub.publish('forumDataListForTop', null);
                    this.getForumTop();
                    this.getTypeForumInfoFunc();
                }
                this.fixedmenu();
            }
        },
        activated() {
            //固定左右菜单
            this.fixedmenu();
        },
        deactivated() {
            this.closeYlVideodialog();
        }
    };
</script>
<style scoped>
    .quill-editor /deep/ .ql-container {}
    /deep/ input[type=file] {
        display: none;
    }
    .heiseplayertck /deep/ .el-dialog {
        background-color: #f5f5f5;
    }
    .heiseplayertck /deep/ .el-dialog__title {
        color: #f3f3f3;
    }
    .heiseplayertck /deep/ .el-dialog__close {
        color: #fff;
    }
    .heiseplayertck1 /deep/ .el-dialog {
        background-color: #f5f5f5;
        height: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .heiseplayertck1 /deep/ .el-dialog__title {
        color: #f3f3f3;
    }
    .heiseplayertck /deep/ .el-dialog__close {
        color: #fff;
    }
    .riqixzq {
        transform: scale(0.9);
        margin-left: -20px;
    }
</style>
<style>
    .msgboxgf {
        max-width: 420px;
        width: 100%;
    }
    .top-bar {
        position: fixed;
        /* 针对Safari浏览器的兼容性 */
        position: sticky;
        top: 0;
        /* 距离页面顶部的距离 */
        background-color: white;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        z-index: 1000;
        /* 确保该区块在最上层 */
    }
    .button-container {
        text-align: center;
    }
    .sticky-block {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 1000; /* 确保块在顶部 */
  transition: all 0.3s; /* 可选的过渡效果 */
}
 
  .posts {
  /* 样式按需添加 */
   width: 100%;
   height: 100px;

}
 
  .post {
  /* 样式按需添加 */
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;
  max-width: 420px;
  height: 20px;

}
</style>